import { useContext, useEffect, useState } from "react";
import InputFilterBox from "../InputFilterBox/web"
import { ConfigStateContext } from "shared-components/Contexts/Configurations/context";
import { useFilters } from "shared-components/Components/Filters/Filters.hook";
import { currencyType } from "../options";
import Show from "src/Components/Show/web";
import { useSearchResultsFilters } from "../../Filters/SearchResultsFilters.hook";
import { formatMoney, parserMoney } from "@Utils/Functions";
import { firstLetterToUppercase, validateRange } from "src/utils/Functions";
import './styles.less'

export const RangePriceFilter = () => {
    const { filters } = useFilters();
    const { country_code, translations } = useContext(ConfigStateContext);
    const { changeFiltersAndUpdateURL: changeFilters } = useSearchResultsFilters();

    const [currentCurrency, setCurrentCurrency] = useState({} as any);
    const [currencySymbol, setCurrencySymbol] = useState('');
    const [minPrice, setMinPrice] = useState('');
    const [maxPrice, setMaxPrice] = useState('');
    const [commonExpenses, setCommonExpenses] = useState(false);
    const [errorMessage, setErrorMessage] = useState<string>('')

    const currenciesByCountry = currencyType.filter(currency => currency.countries.includes(country_code ? country_code.toUpperCase() : ""))
    const currenciesList = currenciesByCountry.map((currency) => ({ text: currency.text, value: currency.value }));

    useEffect(() => {
        if (filters?.commonExpenses) {
            setCommonExpenses(filters?.commonExpenses)
        }
    }, [filters?.commonExpenses])

    useEffect(() => {
        let current = currenciesList[0];
        let symbol = '';
        const getCurrencySymbol = (currencyText) => currencyText.split(' ')[0];

        if (filters.currencyID) {
            current = currenciesList.find((currency) => currency.value === filters.currencyID) || currenciesList[0];
        }

        symbol = getCurrencySymbol(current.text);
        setCurrentCurrency(current);
        setCurrencySymbol(symbol);
    }, [filters?.currencyID])

    useEffect(() => {
        if (filters?.minPrice) {
            setMinPrice(filters?.minPrice);
        } else {
            setMinPrice('');
        }

        if (filters?.maxPrice) {
            setMaxPrice(filters?.maxPrice);
        } else {
            setMaxPrice('');
        }
    }, [filters.minPrice, filters.maxPrice])

    useEffect(() => {
        setErrorMessage(validateRange(minPrice, maxPrice, 'El precio mínimo no puede ser mayor al precio máximo'))
    }, [minPrice, maxPrice])


    const handleClick = (e) => {
        const { value } = e.target;
        changeFilters({ currencyID: { text: undefined, value: Number(value) } });
    }

    const toogleCurrencies = () => {
        return currenciesList.map((val, i) => (
            <div
                key={val.text + "-" + i}
                className="priceRangeFilter__currency__option"
            >
                <input
                    type="radio"
                    className="radioCustomInput"
                    name={"currencyID"}
                    id={val.text}
                    checked={filters?.currencyID === Number(val.value)}
                    value={val.value}
                    onClick={handleClick}
                />
                <label htmlFor={val.text}>{val.text}</label>
            </div>
        ))
    }

    const handleMinPriceChange = (e) => {
        const cleanNumber = e.target.value.replace(/\D/g, '');
        setMinPrice(cleanNumber)
    }

    const handleMaxPriceChange = (e) => {
        const cleanNumber = e.target.value.replace(/\D/g, '');
        setMaxPrice(cleanNumber)
    }

    const handleCommonExpensesChange = (e) => {
        setCommonExpenses(e.target.checked)
    }

    const submitPrice = () => {
        const validationError = validateRange(minPrice, maxPrice, 'El precio mínimo no puede ser mayor al precio máximo')

        if (validationError) {
            setErrorMessage(validationError)
            return
        }

        const res = {
            minPrice: minPrice ? { text: `Desde ${currencySymbol} ${formatMoney(minPrice)}`, value: parserMoney(minPrice) } : undefined,
            maxPrice: maxPrice ? { text: `Hasta ${currencySymbol} ${formatMoney(maxPrice)}`, value: parserMoney(maxPrice) } : undefined,
            currencyID: { text: undefined, value: currentCurrency.value },
            commonExpenses: commonExpenses ? { value: commonExpenses, text: firstLetterToUppercase(translations.gastosComunes) } : null
        }

        changeFilters(res);
        setErrorMessage('')
    }

    const clearValue = async (setValue, value) => {
        await setValue('');
        if (filters[value]) {
            changeFilters({ [value]: undefined })
        }
    }

    return (
        <InputFilterBox label="Precio" customWidth={280}>
            <div className="priceRangeFilter">
                <Show when={country_code !== "CO"}>
                    <div className="priceRangeFilter__currency">
                        {toogleCurrencies()}
                    </div>
                </Show>
                <div className="priceRangeFilter__range">
                    <div className="priceRangeFilter__range__box">
                        <input
                            type="text"
                            className="priceRangeFilter__range__input boxCustomInput"
                            placeholder={`Min ${currencySymbol}`}
                            onChange={handleMinPriceChange}
                            value={formatMoney(minPrice)}
                        />
                        {minPrice && <button onClick={() => clearValue(setMinPrice, "minPrice")} className="clear-button">X</button>}
                    </div>
                    -
                    <div className="priceRangeFilter__range__box">
                        <input
                            type="text"
                            className="priceRangeFilter__range__input boxCustomInput"
                            placeholder={`Max ${currencySymbol}`}
                            onChange={handleMaxPriceChange}
                            value={formatMoney(maxPrice)}
                        />
                        {maxPrice && <button onClick={() => clearValue(setMaxPrice, "maxPrice")} className="clear-button">X</button>}
                    </div>
                </div>
                {errorMessage && <p className="errorMessage">{errorMessage}</p>}

                {(filters.operation_type_id === 2 && country_code !== "CO") &&
                    <div
                        className="otherFilters__container__option"
                    >
                        <input
                            type="checkbox"
                            className="checkBoxCustomInput"
                            name="commonExpenses"
                            onChange={handleCommonExpensesChange}
                            checked={commonExpenses}
                            id="common-expenses"
                        />
                        <label htmlFor="common-expenses" className='body body-2 body-regular'>{firstLetterToUppercase(translations.gastosComunes)}</label>
                    </div>
                }

                <button
                    className="priceRangeFilter__submitButton btn-secondary w-full"
                    onClick={submitPrice}
                    disabled={errorMessage !== '' || !minPrice && !maxPrice}
                >
                    Aplicar rango
                </button>
            </div>
        </InputFilterBox>
    )
}